import React from 'react';

// Routes
import Routes from './applicants-all-routes';

export default function (props) {

  
  return (
   <div>
       <Routes />
   </div>
  )
}
